import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { EyeOff, Activity } from 'lucide-react';
export function ProblemSection() {
  const container = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const item = {
    hidden: {
      opacity: 0,
      y: 20
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8
      }
    }
  };
  return <section className="py-20 bg-transparent text-[#3A3A3A] px-4" data-id="element-274">
      <div className="max-w-4xl mx-auto" data-id="element-275">
        <motion.div initial="hidden" whileInView="show" viewport={{
        once: true
      }} variants={container} className="space-y-16" data-id="element-276">
          {/* Opening Lead */}
          <div className="space-y-6 text-lg md:text-xl text-[#7A7A7A] leading-relaxed border-l-2 border-[#5BBFB5]/30 pl-6 md:pl-10 font-light" data-id="element-277">
            <motion.p variants={item} data-id="element-278">
              Hay un tipo de ansiedad que no te da "tiempo".
            </motion.p>
            <motion.p variants={item} data-id="element-279">
              No llega con aviso. No llega cuando estás en casa meditando.
            </motion.p>
            <motion.p variants={item} className="text-[#3A3A3A] font-medium" data-id="element-280">
              Llega cuando vas tarde. Cuando el metro va lleno. Cuando te
              escriben ese mensaje.
            </motion.p>
            <motion.p variants={item} data-id="element-281">
              Y lo peor no es el síntoma. Es el pensamiento que viene detrás:
            </motion.p>
            <motion.p variants={item} className="text-2xl md:text-3xl font-semibold text-[#3A3A3A] italic" data-id="element-282">
              "Por favor que no se note."
            </motion.p>
          </div>

          {/* Pain Points Grid */}
          <div className="grid md:grid-cols-2 gap-8 mt-12" data-id="element-283">
            <motion.div variants={item} className="bg-white p-8 rounded-2xl border border-[#E8E8E6] shadow-sm" data-id="element-284">
              <div className="w-12 h-12 bg-[#5BBFB5]/10 rounded-full flex items-center justify-center mb-6" data-id="element-285">
                <Activity className="w-6 h-6 text-[#5BBFB5]" data-id="element-286" />
              </div>
              <h3 className="text-xl font-semibold mb-3 text-[#3A3A3A]" data-id="element-287">
                El miedo al desborde
              </h3>
              <p className="text-[#7A7A7A] font-light leading-relaxed" data-id="element-288">
                Sientes que el pecho se aprieta y la mente acelera. No quieres
                un consejo bonito. Quieres un botón de apagado.
              </p>
            </motion.div>

            <motion.div variants={item} className="bg-white p-8 rounded-2xl border border-[#E8E8E6] shadow-sm" data-id="element-289">
              <div className="w-12 h-12 bg-[#5BBFB5]/10 rounded-full flex items-center justify-center mb-6" data-id="element-290">
                <EyeOff className="w-6 h-6 text-[#5BBFB5]" data-id="element-291" />
              </div>
              <h3 className="text-xl font-semibold mb-3 text-[#3A3A3A]" data-id="element-292">
                Por qué fallan los tips
              </h3>
              <p className="text-[#7A7A7A] font-light leading-relaxed" data-id="element-293">
                En crisis se te olvida todo. La meditación es lenta y la terapia
                no está ahí en el minuto 1. Necesitas algo mecánico.
              </p>
            </motion.div>
          </div>

          {/* The Pivot */}
          <motion.div variants={item} className="text-center pt-10" data-id="element-294">
            <p className="text-2xl font-medium text-[#3A3A3A] mb-4" data-id="element-295">
              No necesitas "curarte" en 5 minutos.
            </p>
            <p className="text-[#7A7A7A] max-w-2xl mx-auto font-light" data-id="element-296">
              Necesitas un protocolo secuencial que baje tu activación de un
              9/10 a un 6/10. Ese margen te devuelve el control.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}